/**
 * The POSIX-style US timezone codes in the timezone CodeSystem, each with the IANA zone it follows.
 *
 * tzdata 2024b turned these codes into aliases of the city zones, so both give the same offsets.
 * From tzdata 2026e, ICU labels the POSIX codes by offset (`GMT-4`) instead of by abbreviation
 * (`EDT`). Formatting in the city zone keeps the abbreviation.
 */
export const LEGACY_POSIX_TIMEZONES: Readonly<Record<string, string>> = {
  CST6CDT: "America/Chicago",
  EST5EDT: "America/New_York",
  MST7MDT: "America/Denver",
  PST8PDT: "America/Los_Angeles",
};
